import React, { useContext } from 'react';
import { useQuery } from 'react-apollo-hooks';
import { groupMembersQuery } from '../../../../queries/groups';
import {
  GroupMembersQuery,
  GroupMembersQueryVariables
} from '../../../../queries/__generated__/GroupMembersQuery';
import { Card } from '../../../ui';
import { ErrorScreen, Loading } from '../../../utils';
import { Group } from '../types';
import AddMemberToGroupModal from './AddMemberToGroupModal';
import MemberList from './MemberList';
import { UserContext } from '../../../../context/UserContext';

interface GroupMemberListProps {
  group: Group;
}

const GroupMemberList: React.FC<GroupMemberListProps> = ({ group }) => {
  const [showInviteModal, setShowInviteModal] = React.useState(false);
  const { user } = useContext(UserContext);

  const { data, loading, error } = useQuery<GroupMembersQuery, GroupMembersQueryVariables>(
    groupMembersQuery,
    { variables: { input: { groupId: group.id } } }
  );
  if (loading) return <Loading />;
  if (error) return <ErrorScreen error={error.message} />;

  const groupMembers = data!.groupMembers;
  const activeMember = groupMembers.filter(member => member.member.user.id === user.id)[0];
  const userIsAdmin = activeMember.roleType.toUpperCase() === 'ADMIN';

  return (
    <>
      <Card className="pa4 mb2">
        <div className="flex justify-between items-baseline mb3">
          <h2 className="f5 fw6 mv0">Group Contributors</h2>

          {userIsAdmin && (
            <button
              className="f7 blue hover-navy"
              onClick={() => setShowInviteModal(true)}
              data-testid="invite-member-button"
            >
              Add Contributor
            </button>
          )}
        </div>

        <MemberList group={group} groupMembers={groupMembers} userIsAdmin={userIsAdmin} />
      </Card>

      {showInviteModal && (
        <AddMemberToGroupModal
          closeModal={() => setShowInviteModal(false)}
          group={group}
          groupMembers={groupMembers}
        />
      )}
    </>
  );
};

export default GroupMemberList;
